import { Capacitor } from '@capacitor/core';

const isLocal = window.location.hostname === '195.154.113.227' && !Capacitor.isNativePlatform();

export const BASE_URL = isLocal 
  ? "http://195.154.113.227:8000/api/"
  : "https://feel-better-company.com/gestion/public/api/";

export const BASE_URL_PROD = isLocal
  ? "http://195.154.113.227:8000/"
  : "https://feel-better-company.com/";

export const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '';